import React from "react";
import { useCapability } from "@/context/AuthContext";

/**
 * iter70 · <Gate cap="canViewDemandAnalytics"> — renders `children`
 * only when the current user's active capability set includes `cap`.
 *
 * Optional `fallback` renders when the capability is absent (e.g.,
 * an "Upgrade to Professional" chip).
 *
 * Never branch on plan names anywhere — only on capabilities.
 */
export default function Gate({ cap, fallback = null, children }) {
  const allowed = useCapability(cap);
  if (allowed) return <>{children}</>;
  return <>{fallback}</>;
}
